import {
    CustomerServiceOutlined, LinkOutlined, SaveOutlined,
} from '@ant-design/icons';
import {
    Col,
    ConfigProvider,
    FloatButton,
    Layout, Row, theme,
} from 'antd';
import { useMemo } from 'react';
import { CSSProperties } from 'react';
import { Outlet } from 'react-router-dom';

import {
    AppFooter, AppHeader, SupportTicketModal,
} from '@/components';
import {
    FloatingFormSaveProvider, useFloatingFormSaveRegistration,
} from '@/contexts/FloatingFormSaveContext';
import { useUIStore } from '@/stores';

const layoutStyle: CSSProperties = {
    minHeight: '100vh',
};

const contentStyle: CSSProperties = {
    padding: theme.getDesignToken().paddingSM,
};

const FLOAT_BUTTON_SIZE_PX = 52;
const floatButtonStyle: CSSProperties = {
    width: FLOAT_BUTTON_SIZE_PX,
    height: FLOAT_BUTTON_SIZE_PX,
};

const PageLayoutContent = () => {
    const { token } = theme.useToken();
    const { supportTicketModalOpen, setSupportTicketModalOpen, projectCrmFloatUrl } = useUIStore();
    const floatingSave = useFloatingFormSaveRegistration();

    const handleSupportTicketClick = () => {
        setSupportTicketModalOpen(true);
    };

    const handleCloseSupportTicketModal = () => {
        setSupportTicketModalOpen(false);
    };

    const saveBlocked = floatingSave
        ? floatingSave.submitDisabled || floatingSave.loading
        : false;

    const saveFloatStyle = useMemo((): CSSProperties | undefined => {
        if (!saveBlocked || !floatingSave) {
            return undefined;
        }
        return {
            opacity: 0.55,
            cursor: 'not-allowed',
            backgroundColor: token.colorFillTertiary,
            color: token.colorTextDisabled,
            boxShadow: 'none',
        };
    }, [saveBlocked, floatingSave, token.colorFillTertiary, token.colorTextDisabled]);

    return (
        <Layout style={layoutStyle}>
            <AppHeader />
            <Layout.Content style={contentStyle} className="page-layout-content">
                <Row justify="center">
                    <Col className="main-content-container" style={{ maxWidth: 1440, width: '100%' }}>
                        <Outlet />
                    </Col>
                </Row>
            </Layout.Content>
            <AppFooter />
            <FloatButton.Group>
                <FloatButton.BackTop className="app-float-btn" style={floatButtonStyle} />
                {floatingSave && (
                    <FloatButton
                        className="app-float-btn"
                        icon={<SaveOutlined />}
                        type={saveBlocked ? 'default' : 'primary'}
                        tooltip={floatingSave.submitLabel}
                        disabled={saveBlocked}
                        style={{ ...floatButtonStyle, ...(saveFloatStyle || {}) }}
                        onClick={() => {
                            if (saveBlocked) {
                                return;
                            }
                            floatingSave.requestSubmit();
                        }}
                    />
                )}
                {projectCrmFloatUrl && (
                    <ConfigProvider
                        theme={{
                            token: {
                                colorPrimary: token.colorSuccess,
                                colorPrimaryHover: token.colorSuccessHover,
                                colorPrimaryActive: token.colorSuccessActive,
                            },
                        }}
                    >
                        <FloatButton
                            className="app-float-btn"
                            icon={<LinkOutlined />}
                            tooltip="Перейти на CRM"
                            type="primary"
                            style={floatButtonStyle}
                            onClick={() => window.open(projectCrmFloatUrl, '_blank')}
                        />
                    </ConfigProvider>
                )}
                {/* Запит на підтримку — тимчасово приховано */}
                {/* <FloatButton
                    className="app-float-btn"
                    icon={<CustomerServiceOutlined />}
                    tooltip="Запит на підтримку"
                    style={floatButtonStyle}
                    onClick={handleSupportTicketClick}
                /> */}
            </FloatButton.Group>
            <SupportTicketModal
                open={supportTicketModalOpen}
                onClose={handleCloseSupportTicketModal}
            />
        </Layout>
    );
};

export const PageLayout = () => (
    <FloatingFormSaveProvider>
        <PageLayoutContent />
    </FloatingFormSaveProvider>
);
